<template>
  <kst-page-export
    :catalog="TrxSearchCatalog"
    :params="Model.UrlParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :access="access"
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithTransList"
      :label="Info.Export.Excel.Option.TransList"
    />
  </kst-page-export>
</template>

<script>
import Info from "../TrxInfo.js";
import Model from "../TrxModel.js";
import Services from "../../../services/Api/TransactionServices.js";
import TrxSearchCatalog from "../TrxSearchCatalog.js";

import Export from "./TrxEx_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    Model: Model,
    TrxSearchCatalog: TrxSearchCatalog,
    access: {},
    searchData: {
      Date: null,
      ItemID: null,
      WarehouseID: null,
      TransactionTypeID: null
    },
    userData: {
      WithTransList: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = {
        item: this.$kst.Out.getInteger(this.searchData.ItemID),
        transactiontype: this.$kst.Search.getValue(
          this.searchData.TransactionTypeID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1])
      };

      const config = Services.getExport(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** by export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);

      this.userData.WithTransList = true;
    }
  }
}
</script>